import { ExperimentClient } from '@amplitude/experiment-js-client';
import type { ExperimentConfig } from '@amplitude/experiment-js-client';

import { uiConfig } from '@/config/uiConfig';

const config: ExperimentConfig = {
  fetchOnStart: true,
  debug: uiConfig.environment === 'stage',
};

const experimentClient: ExperimentClient = new ExperimentClient(uiConfig.amplitudeApiKey, config);

export async function initializeAmplitude(): Promise<void> {
  await experimentClient.start();
}

export function getExperimentVariant(key: string, fallback?: string): unknown {
  return experimentClient.variant(key, fallback);
}

export default experimentClient;
